import React from "react";
import "./App.css";
import Login from "./login/login.js";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DataProvider } from "./context/dataprovider.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./Protector/RouteProtector.js";
import AdministratorDashboard from "./pages/Administrator/administratorDashboard.js";
import RootLayout from "./layout/RootLayout.js";
import TransactionsTable from "./pages/Transactions/TransactionsTable.js";
import Dashboard from "./pages/dashboard/Dashboard.js";

function App() {
  const querClient = new QueryClient();

  return (
    <QueryClientProvider client={querClient}>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "8px",
            background: "#333",
            color: "#fff",
          },
          success: {
            style: {
              background: "green",
            },
          },
          error: {
            style: {
              background: "#ff4444",
            },
          },
        }}
      />
      <ToastContainer />
      <DataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />

            <Route
              element={
                <ProtectedRoute>
                  <RootLayout />
                </ProtectedRoute>
              }
            >
              <Route
                path="/administrator-dashboard"
                element={<AdministratorDashboard />}
              />
              <Route path="/transactions" element={<TransactionsTable />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </QueryClientProvider>
  );
}

export default App;
